import React from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { Heading ,Box ,Text,Flex, VStack} from '@chakra-ui/react';

const Performance = () => {
  return (

        <VStack>
        
        <Box  w="32%" m="auto"   ><Heading as='h3' size='lg' >Performance</Heading></Box>
      
        </VStack>
 
    
  );
}

export default Performance;
